import React, {useState, useEffect} from 'react';
import * as Yup from 'yup';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Form, Formik, FormikProps } from 'formik';


import { addUrl } from './helper';
import {withFormikFormControl} from "../../FormikFormControl";
import {ProgressSpinner} from "primereact/progressspinner";
import {Card} from "primereact/card";
import AttachmentViewer from "./AttachmentViewer";

export type ModalFullScreenViewProps = OpenControls & {
  attachment: any
};


const DialogFullScreenView = ({ attachment, handleClose, isOpen }: ModalFullScreenViewProps) => {

  return (
    <Dialog
      header={`Attachment Viewer${attachment?.filename ? ` - ${attachment.filename}` : ''}`}
      visible={isOpen}
      onHide={handleClose}
      maximized
    >
      <AttachmentViewer attachment={attachment} fullscreen={true} env={'dialog'}/>
    </Dialog>
  );
};

export default DialogFullScreenView;
